import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { CircularProgress } from "@mui/material";

const MetricCard = ({ metrics: incomingMetrics = [], isLoading = false }) => {
  const defaultMetrics = [
    {
      title: "Voicemails Transcribed",
      value: "0",
      subtitle: "0% of Plan Total",
      subtitleColor: "orange",
      icon: MessageOutlinedIcon,
      iconColor: "text-statsOrange",
    },
    {
      title: "Transcription Minutes",
      value: "0",
      subtitle: "+12% from last month",
      subtitleColor: "blue",
      icon: WatchLaterIcon,
      iconColor: "text-statsBlue",
    },
    {
      title: "SMS Transcriptions",
      value: "0",
      subtitle: "0 delivered",
      subtitleColor: "bright",
      icon: GraphicEqIcon,
      iconColor: "text-statsBright",
    },
    {
      title: "Success Rate",
      value: "0.0%",
      subtitle: "+0.5% from last week",
      subtitleColor: "green",
      icon: TrendingUpIcon,
      iconColor: "text-statsGreen",
    },
  ];

  const metrics =
    incomingMetrics.length > 0
      ? incomingMetrics.map((metric, index) => ({
          ...defaultMetrics[index],
          ...metric,
        }))
      : defaultMetrics;

  const getSubtitleColorClass = (color) => {
    switch (color) {
      case "orange":
        return "text-statsOrange";
      case "blue":
        return "text-statsBlue";
      case "green":
        return "text-statsGreen";
      case "bright":
        return "text-statsBright";
      default:
        return "text-subtle";
    }
  };
  return (
    <>
      {/* Metrics Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {metrics.map((metric, index) => {
          const IconComponent = metric.icon || MessageOutlinedIcon;

          return (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm p-5 sm:p-10 relative border border-line hover:shadow-md transition-all duration-300 hover:bg-primary/5 flex flex-col justify-between"
            >
              {/* Title and Icon row */}
              <div className="flex justify-between items-center mb-12">
                <div className="text-lg font-bold text-content">
                  {metric.title}
                </div>
                <div className={`w-6 h-6 ${metric.iconColor} flex-shrink-0`}>
                  <IconComponent className="w-full h-full" />
                </div>
              </div>

              <div>
               {/* Main Value */}
               <div className="text-3xl font-bold text-content mb-2">
                 {isLoading ? (
                   <span className="flex items-center gap-2 text-xs font-semibold text-muted">
                     <CircularProgress size={16} thickness={5} sx={{ color: "#0b1f3a" }} />
                     Loading
                   </span>
                 ) : (
                   metric.value
                 )}
               </div>

               {/* Subtitle */}
               <div
                 className={`text-base font-bold ${
                   isLoading ? "text-subtle" : getSubtitleColorClass(metric.subtitleColor)
                 }`}
               >
                 {isLoading ? "Fetching metrics..." : metric.subtitle}
               </div>
              </div>

            </div>
          );
        })}
      </div>
    </>
  );
};

export default MetricCard;
